$(function () {

    /*アラートライブラリ*/
    window.Swal = require('sweetalert2');
    
    // パスセット
    //window.mypath = window.location.protocol + '//' + window.location.host;

    // Ajaxセットアップ
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

});

